import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMyContext } from "../contexts/StateHolder";
import SaveModal from "./Modal/SaveModal";

export default function SideNavBar(props) {
    const { t } = useTranslation();

    const [checkTimeline, setcheckTimeline] = useState(null);
    const [showNewProjectNameModal, setShowNewProjectNameModal] = useState(false);
    const [newProjectName, setNewProjectName] = useState("");

    const [isValid, setIsValid] = useState(true)
    const { timeline } = useMyContext();



    console.log('timeline-bishal', timeline)

    useEffect(() => {
        if (timeline) {
            const { video = [], audio = [] } = timeline || {};

            console.log('video,audio,sidenavbar', video, audio,)

            const invalidItems = [
                // all audio tracks
                ...(timeline?.audio || []),
                // only videotrack0
                ...(timeline?.video || []).filter(track => track.id === "videotrack0"),
            ]
                .flatMap(track =>
                    (track.items || []).filter(
                        item => typeof item.isValid === "boolean" && item.isValid === false
                    )
                );

            console.log("invalidItems-bishal", invalidItems);

            if (invalidItems.length > 0) {
                console.log("⚠️ Found invalid items:", invalidItems);
                setIsValid(false)
            } else {
                console.log("✅ All items are valid");
                setIsValid(true)
            }

            setcheckTimeline(timeline);
        }
    }, [JSON.stringify(timeline)]);

    const exportToSuiteButtonHandler = () => {
        if (checkTimeline.video[0].items.length > 0) {
            props.fileUploadSuiteModal();
        } else {
            return toast.error(`${t("error.noFilesAddVideoToTimeline")}`);
        }
    };

    const saveProject = () => {
        props.updateProject(newProjectName);
        setShowNewProjectNameModal(false);
        toast.info(`${t("shared.projectRenamed")}  ${newProjectName}`);
        return setNewProjectName("");
    };

    const SideNavBarButtons = [
        {
            icon: <FontAwesomeIcon icon="folder" />,
            link: true,
            route: "/",
            id: 1,
            text: t("newProjectDialog.allProjects"),
        },
        {
            icon: <FontAwesomeIcon icon="file-export" />,
            id: 2,
            text: t("sideNavBar.exportSuite"),
            onClick: () => {
                exportToSuiteButtonHandler();
            },
            disabled: !isValid
        },
        {
            icon: <FontAwesomeIcon icon="save" />,
            onClick: () => {
                setShowNewProjectNameModal(true);
            },
            id: 3,
            text: t("sideNavBar.saveas"),
            disabled: false
        },
    ];

    return (
        <>
            {showNewProjectNameModal && (
                <>
                    <SaveModal
                        inputValue={newProjectName}
                        setInputValue={setNewProjectName}
                        inputLabel={t("newProjectDialog.projectName")}
                        confirmHandler={saveProject}
                        cancelHandler={() => setShowNewProjectNameModal(false)}
                    />
                </>
            )}
            <div className="sidebar-info">
                {SideNavBarButtons.map((el) => {
                    return el?.link ? (
                        <Link to={el?.route} key={el?.id.toString()}>
                            <div className="sidebar-info__icon">{el?.icon}</div>
                            <div className="sidebar-info__text">{el?.text}</div>
                        </Link>
                    ) : (
                        <button onClick={el?.onClick} key={el?.id.toString()} disabled={el?.disabled}

                            style={{
                                opacity: el?.disabled ? 0.5 : 1,
                                cursor: el?.disabled ? "not-allowed" : "pointer",
                                backgroundColor: el?.disabled ? "transparent" : "inheritt",
                                border: "none",
                            }}
                        >
                            <div className="sidebar-info__icon">{el?.icon}</div>
                            <div className="sidebar-info__text">{el?.text}</div>

                        </button>
                    );
                })}
            </div>
        </>
    );
}
